// components/CallStatusTooltip.jsx
import React, { useState } from 'react';
import { Tooltip, Popover, Typography, useMediaQuery } from '@mui/material';
import { CALL_STATUS_MESSAGES } from '../utils/constants';

const getStatusMessage = (key) => {
  const status = CALL_STATUS_MESSAGES.find((item) => item.key === key);
  return status ? status.value : "Unknown Status";
};

export const CallStatusTooltip = ({ statusKey, sx = {} }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (isMobile) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const baseStyles = {
    color: "#1976d2",
    display: "block",
    whiteSpace: "nowrap",
    fontSize: "inherit",
    ...sx,
  };

  return (
    <>
      {isMobile ? (
        <>
          <span onClick={handleClick} style={baseStyles}>
            {statusKey}
          </span>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Typography sx={{ p: 2, maxWidth: "200px" }}>
              {getStatusMessage(statusKey)}
            </Typography>
          </Popover>
        </>
      ) : (
        <Tooltip title={getStatusMessage(statusKey)} arrow>
          <span style={baseStyles}>{statusKey}</span>
        </Tooltip>
      )}
    </>
  );
};